import React from 'react';

import { DEFAULT_PORTFOLIO_NAME } from '@scripts/utilities/constants.js'
import Debounce from '@scripts/utilities/debounce.js';

import Accordion from '../../Accordion/index.jsx';

import AssetSelect from '../AssetSelect/index.jsx';
import BlockchainSelect from '../BlockchainSelect/index.jsx';
import CategorySelect from '../CategorySelect/index.jsx';
import Button from 'react-bootstrap/Button';
import ConfirmationButton from '../../ConfirmationButton/index.jsx';
/**
 * Edit component, allows users to add/remove the assets they are interested in
 */
class EditPortfolio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedPortfolio: this.props.selectedPortfolio,
    };
    this.nameRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if(this.props.selectedPortfolio?.id !== prevProps.selectedPortfolio?.id) {
      this.setState({selectedPortfolio: this.props.selectedPortfolio}, () => {
        this.nameRef.current.focus();
      });
    }
  }

  savePortfolio(forceClose = false) {
    this.props.savePortfolio({
      name: DEFAULT_PORTFOLIO_NAME,
      ...this.state.selectedPortfolio
    }, forceClose);
  }

  render() {
    const debouncedName = Debounce(() => this.savePortfolio(), 1000);
    const { assets = [], blockchains = [], categories = [], name } = this.state.selectedPortfolio;
    return (
      <Accordion title={<strong>Customise your portfolio</strong>}>
        <p><strong>Porfolio Name</strong></p>
        <div className="row my-3">
          <div className="col-md-6">
            <input ref={this.nameRef} autoFocus name="PortfolioName" placeholder="Porfolio name" type="text" id="PortfolioName" className="form-control" onChange={(e) => {
              const name = e.target.value;
              this.setState({ selectedPortfolio: {...this.state.selectedPortfolio, name}}, debouncedName);
            }} value={name ?? ''}></input>
          </div>
          <div className="col-md-6 my-1">          
            <ConfirmationButton 
              className=""
              variant="danger"
              type={this.props.type}
              disabled={this.props.loading}
              buttonText="Delete Portfolio"
              modalTitle="Delete Portfolio"
              modalBody="This will permanently remove this portfolio from your dashboard. Are you sure?"
              confirmVariant="danger"
              buttonConfirmText="Yes, delete"
              onConfirm={() => this.props.deletePortfolio(this.state.selectedPortfolio.id)}
            />
          </div>
        </div>
        
        <p>
          <strong>Assets</strong> <br/>
          <label>Select the Assets you are interested in. These will be included in your portfolio. Any articles that are tagged with these Assets will appear in the custom feed on this page.</label>
        </p>
        <AssetSelect value={assets} onChange={(assets) => this.setState({ selectedPortfolio: {...this.state.selectedPortfolio, assets}}, this.savePortfolio)} />
        

        <p>
          <strong>Blockchains</strong> <br/>
          <label>Select the Blockchains you are interested in. Any articles that are tagged with these Blockchains will appear in the custom feed on this page.</label>
        </p>
        <BlockchainSelect value={blockchains} onChange={(blockchains) => this.setState({ selectedPortfolio: {...this.state.selectedPortfolio, blockchains}}, this.savePortfolio)} />
        
        <p>
          <strong>Categories</strong><br/>
          <label>Select the Categories you are interested in. Any articles that are tagged with these Categories will appear in the custom feed on this page.</label>
        </p>
        <CategorySelect value={categories} onChange={(categories) => this.setState({ selectedPortfolio: {...this.state.selectedPortfolio, categories}}, this.savePortfolio)} />

        <p className='text-right'>    
            <Button className="btn-f-right" variant="primary" onClick={() => this.savePortfolio(true)}>Done</Button> 
        </p>
      </Accordion>
    );
  }
}


export default EditPortfolio;

